"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class ButtonCTA extends _react.PureComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.startGuidedSelling = () => {
      this.props.launchFunction();
    };
  }
  componentWillUnmount() {
    delete window.startGuidedSelling;
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
      id: 'gs-cta-button',
      appearance: this.props.appearance,
      inverse: this.props.appearance === 'secondary',
      onClick: () => {
        this.props.launchFunction();
      },
      text: this.props.text
    });
  }
}
exports.default = ButtonCTA;